const save = {
  description: {
    presence: {
      allowEmpty: false,
      message: "Descrição é obrigatória"
    },
    length: {
      maximum: 20,
      message: "Descrição não pode ter mais de 20 caracteres"
    }
  },
  rule_text: {
    presence: {
      allowEmpty: false,
      message: "Regra é obrigatório"
    },
    length: {
      maximum: 250,
      message: "Regra não pode ter mais de 250 caracteres"
    }
  },
  type: {
    presence: {
      allowEmpty: false,
      message: "Tipo de Desconto é obrigatório"
    },
    format: {
      pattern: /^variable_percentual|fixed_percentage|fixed_value|variable_value|$/,
      message: "Tipo de Desconto inválido"
    }
  },
  minimum_value: {
    numericality: {
      lessThan: 1000000000,
      message: "Valor de Desconto não pode ter mais de 10 caracteres"
    }
  },

  discount_value: function(
    value,
    attributes,
    attributeName,
    options,
    constraints
  ) {
    if (["fixed_value", "variable_value"].includes(attributes.type)) {
      return {
        presence: {
          allowEmpty: false,
          message: `Valor de Desconto ${
            attributes.type === "variable_value" ? "Limite" : ""
          } é obrigatório`
        },
        numericality: {
          greaterThan: 0,
          message: `Valor de Desconto ${
            attributes.type === "variable_value" ? "Limite" : ""
          } deve ser maior que zero`
        }
      };
    }
    return {};
  },
  percentual_value: function(
    value,
    attributes,
    attributeName,
    options,
    constraints
  ) {
    if (["fixed_percentage", "variable_percentual"].includes(attributes.type)) {
      const label = {
        variable_percentual: "Percentual de Desconto Limite",
        fixed_percentage: "Percentual de Desconto Fixo"
      };

      return {
        presence: {
          allowEmpty: false,
          message: `${label[attributes.type] || "Percetual"} é obrigatório`
        },
        numericality: {
          greaterThan: 0,
          lessThan: 10001,
          message: `${label[attributes.type] ||
            "Percentual"} deve ser uma porcentagem entre 0,01 e 100`
        }
      };
    }
    return {};
  },
  start_date: function(value, attributes, attributeName, options, constraints) {
    if (value !== "") {
      return {
        simpleDate: {
          allowEmpty: false,
          message: "Vigência Inicial com formato inválido"
        },
        differentFromToday: {
          message: "Vigência Inicial não pode ser inferior ao dia de hoje"
        }
      };
    }

    return {
      presence: {
        allowEmpty: false,
        message: "Vigência Inicial é obrigatória"
      }
    };
  },
  end_date: function(value, attributes, attributeName, options, constraints) {
    if (value !== "") {
      return {
        simpleDate: {
          allowEmpty: true,
          message: "Vigência Final com formato inválido"
        },
        dateIsAfter: {
          attribute: "start_date",
          message:
            "Vigência Final não pode ser igual ou inferior a Vigência Inicial"
        }
      };
    }
  }
};

const edit = save;
delete edit.start_date;
edit.end_date = function(
  value,
  attributes,
  attributeName,
  options,
  constraints
) {
  return {
    simpleDate: {
      allowEmpty: true,
      message: "Vigência Final com formato inválido"
    }
  };
};

export default {
  save,
  edit
};



// WEBPACK FOOTER //
// ./src/core/constraint/discount.constraint.js